import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=b287ba5e&scoped=true&"
import script from "./AddRole.vue?vue&type=script&lang=js&"
export * from "./AddRole.vue?vue&type=script&lang=js&"
import style0 from "./AddRole.vue?vue&type=style&index=0&id=b287ba5e&scoped=true&lang=css&"
import style1 from "./AddRole.vue?vue&type=style&index=1&id=b287ba5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b287ba5e",
  null
  
)

export default component.exports